import {isCnito} from '../../helpers';

export const installOneTrustScript = () => {
    /*
        'cartoonito.cl',
            'cartoonito.com.ar',
            'cartoonito.com.co',
            'cartoonito.com.ec',
            'cartoonito.com.mx',
            'cartoonito.com.pe',
            'cartoonito.com.uy',
            'cartoonito.com.ve',
            'cartoonito.com.br',
            'cartoonitola.com',
    */

    const oneTrust = [
        {
            domain: 'localhost:3000',
            src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
            domainScript: '5f969ccc-69d3-4bb3-994a-aaa8dd8e1fa0-test',
        },
        {
            domain: 'cnplus.qa.dmti.cloud',
            src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
            domainScript: '5f969ccc-69d3-4bb3-994a-aaa8dd8e1fa0-test',
        },
        {
            domain: 'cnapp.cartoonnetwork.com.br',
            src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
            domainScript: '5f969ccc-69d3-4bb3-994a-aaa8dd8e1fa0',
        },
    ];

    const oneTrustCNito = [
        {
            domain: 'localhost:3000',
            src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
            domainScript: '9523a783-5ea5-49fd-a310-efc01948d28c-test',
        },
        {
            domain: 'cnplus.qa.dmti.cloud',
            src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
            domainScript: '9523a783-5ea5-49fd-a310-efc01948d28c-test',
        },
        {
            domain: 'cartoonito.com.br',
            src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
            domainScript: '9523a783-5ea5-49fd-a310-efc01948d28c',
        },
        {
            domain: 'cartoonito.com.ar',
            src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
            domainScript: '2176c117-49c3-45b5-a965-25e3221eb267',
        },
        {
            domain: 'cartoonito.cl',
            src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
            domainScript: '8590fff1-504f-44e7-8af3-2c0114f444e0',
        },
        {
            domain: 'cartoonito.com.co',
            src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
            domainScript: 'e184edb9-0060-4dba-b835-79e7939bfe71',
        },
        {
            domain: 'cartoonito.com.ec',
            src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
            domainScript: '2eece95d-f310-4459-ba72-823c41ee86ac',
        },
        {
            domain: 'cartoonito.com.mx',
            src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
            domainScript: '51304c63-71bf-4af9-ba41-c061eeac61b5',
        },
        {
            domain: 'cartoonito.com.pe',
            src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
            domainScript: 'a23054c2-d4eb-4782-b0b9-1b37e9ad7020',
        },
        {
            domain: 'cartoonito.com.uy',
            src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
            domainScript: '0524cdea-3612-4887-b68d-a2041b368da2',
        },
        {
            domain: 'cartoonito.com.ve',
            src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
            domainScript: 'fe035d4a-1a6f-4574-80e2-f79f75224534',
        },
        {
            domain: 'cartoonitola.com',
            src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
            domainScript: '4f8b27ca-5cf4-435f-bfb7-45d446cd087b',
        },
    ];

    //get script based on current domain
    let domain = window.location.origin.replace(
        /(www.|https:\/\/|http:\/\/)+/g,
        '',
    );
    let configArray = isCnito() ? oneTrustCNito : oneTrust;

    //find the domain in the array
    let config = configArray.find(item => item.domain === domain);
    if (!!config) {
        let oneTrustScript = document.createElement('script');
        let optanonScript = document.createElement('script');

        oneTrustScript.async = true;

        oneTrustScript.src = config.src;
        oneTrustScript.dataset.domainScript = config.domainScript;
        if (localStorage.i18nextLng === 'pt-BR') {
            oneTrustScript.dataset.language = 'pt';
        }

        optanonScript.innerHTML = `

                let configured = false;

                function OptanonWrapper() {

                    let optanonCookie = document.cookie
                        .split('; ')
                        .find(item => item.indexOf('OptanonConsent=') === 0);

                    optanonCookie =
                        optanonCookie &&
                        optanonCookie
                            .replace('OptanonConsent=', '')
                            .split('&')
                            .reduce((acc, curr) => {
                                curr = curr.split('=');
                                return {...acc, [curr[0]]: curr[1]};
                            }, {});

                    if(configured
                        && optanonCookie
                        && optanonCookie.interactionCount !== "2")
                    {
                        window.location.reload();
                    }

                    configured = true;


                }`;

        optanonScript.async = true;
        document.body.appendChild(oneTrustScript);
        document.body.appendChild(optanonScript);

        return {oneTrustScript, optanonScript};
    }

    return {oneTrustScript: null, optanonScript: null};
};
